import { render, staticRenderFns } from "./Previous.vue?vue&type=template&id=10b945c6&"
import script from "./Previous.vue?vue&type=script&lang=js&"
export * from "./Previous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports